import React from "react";

/**
 * Monochrome brand logo tinted with --theme-primary via CSS mask.
 * Keeps natural image size via a hidden sizer <img>.
 */
function ThemeTintedLogo({
  src,
  alt = "Logo",
  className = "",
  sizerClassName = "",
  style,
  onClick,
  onKeyDown,
  role,
  tabIndex,
  width,
  height,
}) {
  const wrapClass = ["theme-tinted-logo-wrap", className].filter(Boolean).join(" ");

  return (
    <span
      className={wrapClass}
      style={style}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
    >
      <img
        src={src}
        alt=""
        aria-hidden="true"
        className={`theme-tinted-logo-sizer ${sizerClassName}`.trim()}
        width={width}
        height={height}
        draggable={false}
      />
      <span
        className="theme-tinted-logo-fill"
        role="img"
        aria-label={alt}
        style={{
          WebkitMaskImage: `url(${src})`,
          maskImage: `url(${src})`,
        }}
      />
    </span>
  );
}

export default ThemeTintedLogo;
